import { render, staticRenderFns } from "./crud.vue?vue&type=template&id=808319de&scoped=true"
import script from "./crud.vue?vue&type=script&lang=ts"
export * from "./crud.vue?vue&type=script&lang=ts"
import style0 from "./crud.vue?vue&type=style&index=0&id=808319de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "808319de",
  null
  
)

export default component.exports